import { EditorContent } from "@tiptap/react";
import { forwardRef } from "react";

import css from "./RichTemplateEditor.module.scss";
import type {
  RichTemplateEditorProps,
  TemplateEditorInsertHandle,
} from "./RichTemplateEditor.types";
import { Toolbar } from "./Toolbar";
import { useRichEditor } from "./useRichEditor";
import { useRichEditorHandle } from "./useRichEditorHandle";

export type RichTemplateEditorHandle = TemplateEditorInsertHandle;

/**
 * WYSIWYG-редактор шаблона (TipTap + ProseMirror). Поддерживает Avito
 * allowlist (`p, br, strong, em, ul, ol, li`) и сохраняет `{{переменные}}`
 * как atom-ноды. Value — template-строка для backend (HTML + `{{vars}}`),
 * onChange срабатывает на каждое локальное изменение.
 *
 * Логика разнесена по хукам (`useRichEditor`, `useRichEditorHandle`) и
 * sub-компонентам (`Toolbar`) — здесь только сборка.
 */
export const RichTemplateEditor = forwardRef<
  RichTemplateEditorHandle,
  RichTemplateEditorProps
>(function RichTemplateEditor(props, ref) {
  const editor = useRichEditor(props);
  useRichEditorHandle(ref, editor);

  return (
    <div className={css.wrapper} data-disabled={props.disabled || undefined}>
      <Toolbar editor={editor} />
      <EditorContent editor={editor} />
    </div>
  );
});
